import ProdutoService from "@/services/ProdutoService";

export const produto = {
  namespaced: true,
  state: {
    Produto: {},
  },
  actions: {
    getProduto({ commit }, payload) {
      return ProdutoService.GetProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProduto({ commit }, payload) {
      return ProdutoService.PostProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProduto({ commit }, payload) {
      return ProdutoService.PutProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProduto({ commit }, payload) {
      return ProdutoService.DeleteProduto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdutoOData({ commit }, payload) {
      return ProdutoService.GetProdutoOData(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    gerarCodigoBarras() {
      return ProdutoService.GerarCodigoBarras().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getProdutoMultiempresaGrade({ commit }, payload) {
      return ProdutoService.GetProdutoMultiempresaGrade(payload).then(
        (produto) => {
          return Promise.resolve(produto);
        },
        (error) => {
          return Promise.reject(error.response?.data || error);
        }
      );
    },
    getRelatorio({ commit }, payload) {
      return ProdutoService.GetRelatorio(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response?.data || error);
        }
      );
    },
    consultarGestorTributos({ commit }, payload) {
      return ProdutoService.ConsultarGestorTributos(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response?.data || error);
        }
      );
    },
    getGestorTributosConsultasOData({ commit }, payload) {
      return ProdutoService.GetGestorTributosConsultasOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getGestorTributosPendenciasOData({ commit }, payload) {
      return ProdutoService.GetGestorTributosPendenciasOData(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error)
      );
    },
    relacionarGestorTributos({ commit }, payload) {
      return ProdutoService.RelacionarGestorTributos(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    consultarRelacionamentoGestorTributos({ commit }, payload) {
      return ProdutoService.ConsultarRelacionamentoGestorTributos(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    postGestorTributosConsulta({ commit }) {
      return ProdutoService.PostGestorTributosConsulta().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response?.data || error);
        }
      );
    },
    validate({ commit }, payload) {
      return ProdutoService.Validate(payload).then(
        (produto) => {
          return Promise.resolve(produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    converter({ commit }, payload) {
      return ProdutoService.Converter(payload).then(
        (produto) => {
          return Promise.resolve(produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default produto;
